import React from "react";

export default function StarExplanation() {
  return (
    /*
    <>
      <h2>What is STAR Voting?</h2>
      <p>
        <b>STAR Voting</b> builds on Approval Voting by allowing is a
        single-winner voting method that allows voters to choose any number of
        candidates.
      </p>
    </>
    */
    <>
      <p>
        STAR (Score, Then Automatic Runoff) Voting is similar to Approval except
        that you indicate your level of support on scale from zero to 5. Zero
        means you do not endorse the candidate at all. And 5 means they are the
        best candidate on the ballot. There can be more than one "best".
      </p>
      <h3>How are votes tallied?</h3>
      <p>After the election, the winner is decided in a two-step process:</p>
      <ol>
        <li>
          The total score is tallied for each candidate and the two highest
          scoring candidates become finalists.
        </li>
        <li>
          Your full vote goes to whichever of those two finalists you scored
          higher, even if neither was your favorite.
        </li>
      </ol>
      <h3>What's cool about this method?</h3>
      <ul>
        <li>
          Eliminates vote splitting and tends to elect consensus winners and
          candidates who would beat all rivals head-to-head.
        </li>
        <li>
          Whether or not your favorite is a finalist, your vote helps prevent
          your worst-case scenario.
        </li>
        <li>
          The 0-5 ratings provide candidates with a more nuanced, less polarized
          picture of voter sentiment.
        </li>
      </ul>
      <hr />
      <p className="nextAction">
        Try it. Score each of the candidates, and then click <b>Vote</b>.
      </p>
    </>
  );
}
